const newEarningResult = (data) => {
  return {
    code: data[0],
    name: data[1],
    month: data[2],
    mc_1Q: data[3],
    mc_2Q: data[4],
    per: data[6],
    pbr: data[7],
    fcf: data[8],
    forcast: {
      sales: data[9],
      operating_profit: data[10],
      ordinary_income: data[11],
      net_income: data[12],
      eps: data[13],
    },
    basis_1q: {
      sales: data[14],
      operating_profit: data[15],
      ordinary_income: data[16],
      net_income: data[17],
      eps: data[18],
    },
    basis_2q: {
      sales: data[19],
      operating_profit: data[20],
      ordinary_income: data[21],
      net_income: data[22],
      eps: data[23],
    },
    forcast_revised: {
      sales: data[24],
      operating_profit: data[25],
      ordinary_income: data[26],
      net_income: data[27],
      eps: data[28],
    },
    return: {
      increased_dividend: data[29],
      share_buyback: data[30],
      stock_split: data[31],
      expanded_benefits: data[32],
    },
  };
};

export const getTableData = (data) => {
  return data.map((d) => newEarningResult(d));
};

export const COLUMNS = [
  {
    header: "会社名",
    accessorKey: "name",
    cell: ({ getValue, row }) => {
      return (
        <>
          {getValue()}
          <br />
          {row.original["code"]}
        </>
      );
    },
  },
  {
    header: "決算月",
    accessorKey: "month",
  },
  {
    header: "時価総額",
    accessorKey: "mc_2Q",
    cell: ({ getValue, row }) => {
      const mc_2Q = getValue();
      const mc_1Q = row.original["mc_1Q"];
      const chg = ((mc_2Q - mc_1Q) / mc_1Q) * 100;
      return (
        <div>
          {mc_2Q}
          <br />({chg.toFixed(2)}%)
        </div>
      );
    },
  },
  {
    header: "PER",
    accessorKey: "per",
  },
  {
    header: "PBR",
    accessorKey: "pbr",
  },
  {
    header: "FCF比率",
    accessorKey: "fcf",
  },
  {
    header: "業績予想",
    columns: [
      {
        header: "売上",
        cell: ({ row }) => {
          const revised = row.original["forcast_revised"]["sales"];
          return (
            <div>
              {Number(row.original["forcast"]["sales"]).toLocaleString()}
              {revised != "" && (
                <>
                  <br />({revised})
                </>
              )}
            </div>
          );
        },
      },
      {
        header: "営利",
        cell: ({ row }) => {
          const revised = row.original["forcast_revised"]["operating_profit"];
          return (
            <div>
              {Number(
                row.original["forcast"]["operating_profit"]
              ).toLocaleString()}
              {revised != "" && (
                <>
                  <br />({revised})
                </>
              )}
            </div>
          );
        },
      },
      {
        header: "経常",
        cell: ({ row }) => {
          const revised = row.original["forcast_revised"]["ordinary_income"];
          return (
            <div>
              {Number(
                row.original["forcast"]["ordinary_income"]
              ).toLocaleString()}
              {revised != "" && (
                <>
                  <br />({revised})
                </>
              )}
            </div>
          );
        },
      },
      {
        header: "純利",
        cell: ({ row }) => {
          const revised = row.original["forcast_revised"]["net_income"];
          return (
            <div>
              {Number(row.original["forcast"]["net_income"]).toLocaleString()}
              {revised != "" && (
                <>
                  <br />({revised})
                </>
              )}
            </div>
          );
        },
      },
      {
        header: "EPS",
        cell: ({ row }) => {
          const revised = row.original["forcast_revised"]["eps"];
          return (
            <div>
              {row.original["forcast"]["eps"]}
              {revised != "" && (
                <>
                  <br />({revised})
                </>
              )}
            </div>
          );
        },
      },
    ],
  },
  {
    header: "業績結果 進捗率 2Q/1Q",
    columns: [
      {
        header: "売上",
        cell: ({ row }) => (
          <div>
            {row.original["basis_2q"]["sales"]} <br />
            {row.original["basis_1q"]["sales"]}
          </div>
        ),
      },
      {
        header: "営利",
        cell: ({ row }) => (
          <div>
            {row.original["basis_2q"]["operating_profit"]}
            <br />
            {row.original["basis_1q"]["operating_profit"]}
          </div>
        ),
      },
      {
        header: "経常",
        cell: ({ row }) => (
          <div>
            {row.original["basis_2q"]["ordinary_income"]}
            <br />
            {row.original["basis_1q"]["ordinary_income"]}
          </div>
        ),
      },
      {
        header: "純利",
        cell: ({ row }) => (
          <div>
            {row.original["basis_2q"]["net_income"]}
            <br />
            {row.original["basis_1q"]["net_income"]}
          </div>
        ),
      },
      {
        header: "EPS",
        cell: ({ row }) => (
          <div>
            {row.original["basis_2q"]["eps"]}
            <br />
            {row.original["basis_1q"]["eps"]}
          </div>
        ),
      },
    ],
  },
  {
    header: "株主還元",
    columns: [
      {
        header: "増減",
        cell: ({ row }) => (
          <div>{row.original["return"]["increased_dividend"]}</div>
        ),
      },
      {
        header: "自社買",
        cell: ({ row }) => <div>{row.original["return"]["share_buyback"]}</div>,
      },
      {
        header: "分割",
        cell: ({ row }) => <div>{row.original["return"]["stock_split"]}</div>,
      },
      {
        header: "優待拡充",
        cell: ({ row }) => (
          <div>{row.original["return"]["expanded_benefits"]}</div>
        ),
      },
    ],
  },
];
